module.exports = __webpack_public_path__ + "static/logo-animated-0c4474c56e83c4f2cade75e19e329e57.svg";